<template>
    <div class="col-md-12">
      <div class="row">
      <div class="col-md-6">
      <application-info-card :app="app" :currentOffice="currentOffice" @update="app = $event;"></application-info-card>

      <salary-expectation-card :app="app" :currentOffice="currentOffice" @update="app = $event;"></salary-expectation-card>
      <documents-card :app="app" :currentOffice="currentOffice" :openSkill="openSkill" @update="app = $event;"></documents-card>
      </div>
      <div class="col-md-6">
        <experience-card :app="app" :currentOffice="currentOffice" @update="app = $event;"></experience-card>
        <education-card :app="app" :currentOffice="currentOffice" @update="app = $event;"></education-card>
      </div>
      </div>
    </div>
</template>

<script>
import ApplicationInfoCard from "@/components/applications/application-info-card.vue";
import SalaryExpectationCard from "@/components/applications/salary-expectation-card.vue";
import FeedbackCard from "@/components/applications/feedback-card.vue";
import DocumentsCard from "@/components/applications/documents-card.vue";
import ExperienceCard from "@/components/applications/working-experience-card.vue";
import EducationCard from "@/components/applications/education-card.vue";
export default {
  name: "applications-general",
  props: {
         app: {},
         currentOffice: {},
         openSkill: { type: Function }
      },
  components: {
    ApplicationInfoCard,
    SalaryExpectationCard,
    FeedbackCard,
    DocumentsCard,
    ExperienceCard,
    EducationCard
  }
};
</script>



// WEBPACK FOOTER //
// src/components/applications/general.vue